export enum ActivityType {
  LeftRightRail = "LeftRightRail",
  Rotation = "Rotation",
  UpDown = "UpDown",
  FourWay = "FourWay",
  LeftRightRepeat = "LeftRightRepeat",
}

// 예시: ActivityType enum을 위한 변환 함수
export function getActivityType(type: string): ActivityType {
  let activityType: ActivityType | null = null;
  switch (type) {
    case "LeftRightRail":
      activityType = ActivityType.LeftRightRail;
      break;
    case "Rotation":
      activityType = ActivityType.Rotation;
      break;
    case "UpDown":
      activityType = ActivityType.UpDown;
      break;
    case "FourWay":
      activityType = ActivityType.FourWay;
      break;
    case "LeftRightRepeat":
      activityType = ActivityType.LeftRightRepeat;
      break;
    default:
      console.error("ActivityType is not valid: " + type);
      activityType = ActivityType.LeftRightRail; // 기본값
      break;
  }
  return activityType;
}

export function getActivityTypeStr(type: ActivityType, t: (key: string) => string): string {
  switch (type) {
    case ActivityType.LeftRightRail:
      return t("common.activity.LeftRightRail");
    case ActivityType.Rotation:
      return t("common.activity.Rotation");
    case ActivityType.UpDown:
      return t("common.activity.UpDown");
    case ActivityType.FourWay:
      return t("common.activity.FourWay");
    case ActivityType.LeftRightRepeat:
      return t("common.activity.LeftRightRepeat");
  }
}
